(function(window, document) {
  "use strict";
  if (window.AuxitoQuickshopRuntime) {
    return;
  }
  var fitmentEngine = window.AuxitoFitmentEngine || null;
  function fallbackDedupeStrings(items) {
    var seen = {};
    return (Array.isArray(items) ? items : []).filter(function(item) {
      var value = String(item || "").trim();
      if (!value || seen[value]) {
        return false;
      }
      seen[value] = true;
      return true;
    });
  }
  var dedupeStrings = fitmentEngine && typeof fitmentEngine.dedupeStrings === "function" ? fitmentEngine.dedupeStrings : fallbackDedupeStrings;
  function getJQueryInstance() {
    return typeof window !== "undefined" ? window.jQuery || window.$ || (window.Shopify && window.Shopify.$ ? window.Shopify.$ : null) : null;
  }
  function parseEmbeddedJson(scriptEl) {
    if (!scriptEl) {
      return null;
    }
    try {
      return JSON.parse(scriptEl.textContent || scriptEl.innerText || "null");
    } catch (error) {
      return null;
    }
  }
  function formatShopifyMoneyCents(value, moneyFormat, fallbackMoneyFormat) {
    var numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return "";
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(numericValue, moneyFormat || fallbackMoneyFormat || window.Shopify.money_format);
      } catch (error) {}
    }
    return "$" + (numericValue / 100).toFixed(2);
  }
  function updateCurrencyNodes(root) {
    if (!root || !root.querySelectorAll || typeof CurrencyConverter === "undefined" || !CurrencyConverter || typeof CurrencyConverter.update !== "function") {
      return;
    }
    Array.prototype.forEach.call(root.querySelectorAll(".money"), function(node) {
      CurrencyConverter.update(node);
    });
  }
  function hydrateQuickshopLazyImages(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    Array.prototype.forEach.call(root.querySelectorAll("img[data-src]"), function(image) {
      var nextSrc = image.getAttribute("data-src") || "";
      if (nextSrc && image.getAttribute("src") !== nextSrc) {
        image.setAttribute("src", nextSrc);
      }
      image.classList.remove("lazyload");
      image.removeAttribute("data-srcset");
    });
    Array.prototype.forEach.call(root.querySelectorAll("img[data-srcset]"), function(image) {
      var nextSrcset = image.getAttribute("data-srcset") || "";
      if (nextSrcset) {
        image.setAttribute("srcset", nextSrcset);
      }
      image.classList.remove("lazyload");
    });
  }
  function initQuickshopThirdParty(payload) {
    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === "function") {
      window.Shopify.PaymentButton.init();
    }
    if (!payload || payload.thirdPartyInitialized || !window.SPR) {
      if (payload) {
        payload.thirdPartyInitialized = true;
      }
      return;
    }
    window.SPR.registerCallbacks();
    window.SPR.initRatingHandler();
    window.SPR.initDomEls();
    window.SPR.loadProducts();
    window.SPR.loadBadges();
    payload.thirdPartyInitialized = true;
  }
  function ensureNativeModalShell() {
    var container = document.querySelector("[data-modal-container]");
    if (container) {
      return container;
    }
    container = document.createElement("div");
    container.setAttribute("data-modal-container", "");
    container.innerHTML = "<div data-modal-inner><div data-modal-content></div></div>";
    document.body.appendChild(container);
    return container;
  }
  function getNativeModalParts() {
    var container = ensureNativeModalShell();
    return {
      container: container,
      inner: container.querySelector("[data-modal-inner]"),
      content: container.querySelector("[data-modal-content]")
    };
  }
  function clearNativeModalClasses(container) {
    if (!container) {
      return;
    }
    Array.prototype.slice.call(container.classList).forEach(function(className) {
      if (className.indexOf("modal--") === 0) {
        container.classList.remove(className);
      }
    });
    container.classList.remove("modal-loaded");
  }
  function positionNativeQuickshopModal() {
    var parts = getNativeModalParts();
    var modalPadding;
    var offset;
    if (!parts || !parts.container || !parts.inner) {
      return;
    }
    modalPadding = parseInt(window.getComputedStyle(parts.container).paddingTop, 10) * 2 || 0;
    offset = (window.innerHeight - modalPadding - parts.inner.offsetHeight) / 2;
    parts.inner.style.marginTop = (offset > 0 ? offset : 0) + "px";
  }
  function ensureQuickshopMarkupLoaded(payload) {
    var jq = getJQueryInstance();
    if (!payload || !payload.quickshopEl || payload.quickshopEl.hasAttribute("data-loaded")) {
      return !!(payload && payload.quickshopEl);
    }
    if (jq) {
      jq(payload.quickshopEl).append(payload.modalHtml);
    } else {
      payload.quickshopEl.insertAdjacentHTML("beforeend", payload.modalHtml);
    }
    payload.quickshopEl.setAttribute("data-loaded", "true");
    hydrateQuickshopLazyImages(payload.quickshopEl);
    updateCurrencyNodes(payload.quickshopEl);
    return true;
  }
  function chunkItems(items, size) {
    var chunks = [];
    var chunkSize = Math.max(1, parseInt(size, 10) || 1);
    var index;
    for (index = 0; index < items.length; index += chunkSize) {
      chunks.push(items.slice(index, index + chunkSize));
    }
    return chunks;
  }
  function createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(resolvePromise, rejectPromise) {
      resolve = resolvePromise;
      reject = rejectPromise;
    });
    return {
      promise: promise,
      resolve: resolve,
      reject: reject
    };
  }
  function buildCartAddRequestBody(formData) {
    var params = new URLSearchParams;
    (Array.isArray(formData) ? formData : []).forEach(function(entry) {
      if (!entry || !entry.name) {
        return;
      }
      params.append(entry.name, String(entry.value == null ? "" : entry.value));
    });
    if (!params.has("quantity")) {
      params.set("quantity", "1");
    }
    return params.toString();
  }
  async function postCartAddRequest(formData) {
    var cartService = window.Auxito && window.Auxito.CartService;
    if (cartService && typeof cartService.postCartAdd === "function") {
      return cartService.postCartAdd(formData);
    }
    var response = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: buildCartAddRequestBody(formData)
    });
    var errorData;
    var errorMessage = "";
    if (response.ok) {
      return response.json();
    }
    try {
      errorData = await response.json();
      errorMessage = errorData && typeof errorData === "object" ? errorData.description || errorData.message || errorData.status || "" : "";
    } catch (error) {}
    throw new Error(errorMessage || "Cart add failed: " + response.status);
  }
  function normalizeVariantOptions(variant, optionCount) {
    var resolvedCount = Math.max(0, parseInt(optionCount, 10) || 0);
    var options = [];
    var index;
    if (Array.isArray(variant && variant.options) && variant.options.length) {
      return variant.options.map(function(optionValue) {
        return String(optionValue == null ? "" : optionValue).trim();
      });
    }
    for (index = 0; index < resolvedCount; index += 1) {
      options.push(String(variant && variant["option" + String(index + 1)] != null ? variant["option" + String(index + 1)] : "").trim());
    }
    return options;
  }
  function normalizeProductOptionVariants(product) {
    var optionCount = Array.isArray(product && product.options) ? product.options.length : 0;
    return (Array.isArray(product && product.variants) ? product.variants : []).map(function(variant) {
      if (!variant || variant.id == null) {
        return null;
      }
      return Object.assign({}, variant, {
        options: normalizeVariantOptions(variant, optionCount)
      });
    }).filter(Boolean);
  }
  function ProductNode(variant) {
    this.variant = variant;
    this.optionsCount = Array.isArray(variant.options) ? variant.options.length : 0;
    this.neighbors = [];
    for (var index = 0; index < this.optionsCount; index += 1) {
      this.neighbors.push([]);
    }
  }
  ProductNode.prototype.addNeighbor = function(variant) {
    for (var index = 0; index < this.optionsCount; index += 1) {
      if (this.variant.options[index] !== variant.options[index]) {
        this.neighbors[index].push(variant);
        break;
      }
    }
  };
  ProductNode.prototype.getValidOptions = function() {
    var options = [];
    for (var index = 0; index < this.optionsCount; index += 1) {
      var variants = [ this.variant ].concat(this.neighbors[index]);
      options[index] = {};
      variants.forEach(function(item) {
        var optionValue = item.options[index];
        options[index][optionValue] = {
          available: options[index][optionValue] && options[index][optionValue].available || item.available
        };
      });
    }
    return options;
  };
  function ProductOptions(product) {
    this.optionsCount = Array.isArray(product.options) ? product.options.length : 0;
    this.variants = normalizeProductOptionVariants(product);
    this.nodeMap = {};
    this.generateNodeMap();
  }
  ProductOptions.prototype.generateNodeMap = function() {
    for (var index = 0; index < this.variants.length; index += 1) {
      var variant = this.variants[index];
      this.nodeMap[variant.id] = new ProductNode(variant);
      for (var neighborIndex = 0; neighborIndex < this.variants.length; neighborIndex += 1) {
        this.nodeMap[variant.id].addNeighbor(this.variants[neighborIndex]);
      }
    }
  };
  ProductOptions.prototype.getVariantFromOptions = function(options) {
    for (var index = 0; index < this.variants.length; index += 1) {
      var variant = this.variants[index];
      var found = true;
      for (var optionIndex = 0; optionIndex < variant.options.length; optionIndex += 1) {
        if (options[optionIndex] !== variant.options[optionIndex]) {
          found = false;
          break;
        }
      }
      if (found) {
        return variant;
      }
    }
    return null;
  };
  ProductOptions.prototype.getClosestVariantFromOptions = function(options) {
    var closestVariant = null;
    var matchingValues = -1;
    for (var index = 0; index < this.variants.length; index += 1) {
      var variant = this.variants[index];
      var tempMatchingValues = 0;
      for (var optionIndex = 0; optionIndex < variant.options.length; optionIndex += 1) {
        if (options[optionIndex] === variant.options[optionIndex]) {
          tempMatchingValues += 1;
        } else {
          break;
        }
      }
      if (tempMatchingValues >= matchingValues) {
        closestVariant = variant;
        matchingValues = tempMatchingValues;
      }
    }
    return closestVariant;
  };
  ProductOptions.prototype.getVariantOrClosestFromOptions = function(options) {
    return this.getVariantFromOptions(options) || this.getClosestVariantFromOptions(options);
  };
  ProductOptions.prototype.getAvailableOptionsFromVariant = function(variant) {
    return variant && this.nodeMap[variant.id] ? this.nodeMap[variant.id].getValidOptions() : [];
  };
  function VariantHelper(product, $variants, $options, onSwitch, namespace) {
    this.product = product;
    this.$variants = $variants;
    this.$options = $options;
    this.onSwitch = onSwitch;
    this.namespace = "." + String(namespace || "auxito-quickshop-variant-helper");
    this.productOptions = new ProductOptions(product);
    this.optionsTypes = {
      select: "select",
      radio: 'input[type="radio"]'
    };
    this.optionsType = this.$options.is(this.optionsTypes.select) ? this.optionsTypes.select : this.$options.is(this.optionsTypes.radio) ? this.optionsTypes.radio : "";
    if (!this.optionsType) {
      return;
    }
    this.bindEvents();
    this.switchVariant(true);
  }
  VariantHelper.prototype.bindEvents = function() {
    var self = this;
    this.$options.on("change" + this.namespace, function() {
      self.switchVariant(false);
    });
  };
  VariantHelper.prototype.switchVariant = function(firstLoad) {
    var options = [];
    var variant;
    var availableOptions;
    var jq = getJQueryInstance();
    if (this.optionsType === this.optionsTypes.select) {
      this.$options.each(function(index, option) {
        options.push(option.value);
      });
    } else if (this.optionsType === this.optionsTypes.radio) {
      this.$options.filter(":checked").each(function(index, option) {
        options.push(option.value);
      });
    }
    variant = this.productOptions.getVariantOrClosestFromOptions(options);
    if (!variant) {
      return;
    }
    availableOptions = this.productOptions.getAvailableOptionsFromVariant(variant);
    if (this.optionsType === this.optionsTypes.select) {
      this.switchSelect(variant, availableOptions);
    } else {
      this.switchRadio(variant, availableOptions);
    }
    this.$variants.val(variant.id);
    if (jq) {
      jq(window).trigger("product-variant-switch", {
        product: this.product,
        variant: variant,
        firstLoad: !!firstLoad
      });
    }
    if (typeof this.onSwitch === "function") {
      this.onSwitch({
        product: this.product,
        variant: variant,
        firstLoad: !!firstLoad
      });
    }
  };
  VariantHelper.prototype.switchSelect = function(variant, availableOptions) {
    for (var optionIndex = 0; optionIndex < this.product.options.length; optionIndex += 1) {
      var $select = this.$options.eq(optionIndex);
      $select.find("option").each(function(index, option) {
        var $option = getJQueryInstance()(option);
        var value = option.value;
        $option.prop("disabled", !(availableOptions[optionIndex] && availableOptions[optionIndex][value] && availableOptions[optionIndex][value].available)).prop("selected", false);
        if (variant.options[optionIndex] === value) {
          $option.prop("disabled", false).prop("selected", true);
        }
      });
    }
  };
  VariantHelper.prototype.switchRadio = function(variant, availableOptions) {
    this.$options.attr("disabled", true).prop("checked", false).attr("data-soldout", false);
    for (var optionIndex = 0; optionIndex < this.product.options.length; optionIndex += 1) {
      var selector = encodeURIComponent(this.product.options[optionIndex]).replace(/%20/g, "+").replace(/[!'()*]/g, function(character) {
        return "%" + character.charCodeAt(0).toString(16).toUpperCase();
      });
      var $options = this.$options.filter('[name="' + selector + '"]');
      $options.each(function(index, option) {
        var $option = getJQueryInstance()(option);
        if (variant.options[optionIndex] === $option.val()) {
          $option.prop("checked", true);
        }
        if (availableOptions[optionIndex] && availableOptions[optionIndex][$option.val()]) {
          $option.attr("disabled", false);
          if (!availableOptions[optionIndex][$option.val()].available) {
            $option.attr("disabled", true).attr("data-soldout", true);
          }
        }
      });
    }
  };
  VariantHelper.prototype.unload = function() {
    this.$options.off(this.namespace);
  };
  function QuickshopGallery(options) {
    this.$gallery = options.$gallery;
    this.settings = options.settings || {};
    this.namespace = "." + String(options.namespace || "auxito-quickshop-gallery");
    this.$slider = this.$gallery.find("[data-product-slider]");
    this.$slides = this.$gallery.find("[data-product-image]");
    this.$pagination = this.$gallery.find("[data-product-slider-pagination]");
    this.$paginationTrigger = this.$gallery.find("[data-product-thumbnail]");
    this.flickity = null;
    this.onThumbClick = this.handleThumbClick.bind(this);
    this.variantChange = this.handleVariantChange.bind(this);
    this.init();
  }
  QuickshopGallery.prototype.init = function() {
    var selectedImage;
    var flickityOptions;
    var self = this;
    if (!this.$slides.length) {
      return;
    }
    hydrateQuickshopLazyImages(this.$gallery[0]);
    this.$paginationTrigger.on("click" + this.namespace, this.onThumbClick);
      if (typeof window.Flickity=== "function" && this.$slider.length && this.$slides.length > 1) {
      selectedImage = this.$slider.find(".image--selected");
      flickityOptions = {
        autoPlay: 0,
        accessibility: true,
        adaptiveHeight: true,
        cellAlign: "left",
        cellSelector: "[data-product-image]",
        pageDots: false,
        imagesLoaded: false,
        prevNextButtons: true,
        wrapAround: true
      };
      if (window.innerWidth < 768) {
        flickityOptions = Object.assign({
          draggable: true,
          friction: .8,
          selectedAttraction: .2
        }, flickityOptions);
      } else {
        flickityOptions = Object.assign({
          draggable: false
        }, flickityOptions);
      }
      if (selectedImage.length) {
        flickityOptions = Object.assign({
          initialIndex: parseInt(selectedImage.attr("data-product-image-index"), 10) || 0
        }, flickityOptions);
      }
      this.flickity = new window.Flickity(this.$slider[0], flickityOptions);
      this.flickity.on("select", function() {
        self.updateActiveSlide(self.flickity.selectedIndex);
      });
      this.updateActiveSlide(this.flickity.selectedIndex || 0);
      return;
    }
    this.updateActiveSlide(this.getSelectedIndex());
  };
  QuickshopGallery.prototype.getSelectedIndex = function() {
    var $selected = this.$slider.find(".image--selected").first();
    return $selected.length ? parseInt($selected.attr("data-product-image-index"), 10) || 0 : 0;
  };
  QuickshopGallery.prototype.select = function(index) {
    if (this.flickity) {
      this.flickity.select(index, false, false);
      return;
    }
    this.updateActiveSlide(index);
  };
  QuickshopGallery.prototype.updateActiveSlide = function(index) {
    var $newSlide = this.$slider.find('[data-product-image-index="' + index + '"]');
    var $newThumbnail = this.$pagination.find('[data-product-thumbnail="' + index + '"]');
    $newSlide.addClass("image--selected").siblings(".image--selected").removeClass("image--selected");
    $newThumbnail.addClass("thumbnail--selected").siblings(".thumbnail--selected").removeClass("thumbnail--selected");
    if (!this.flickity && this.$slides.length) {
      this.$slides.hide();
      $newSlide.show();
    }
    hydrateQuickshopLazyImages($newSlide[0]);
  };
  QuickshopGallery.prototype.handleThumbClick = function(event) {
    var target = event.currentTarget;
    event.preventDefault();
    this.select(parseInt(target.getAttribute("data-product-thumbnail"), 10) || 0);
  };
  QuickshopGallery.prototype.handleVariantChange = function(variant) {
    var mediaId;
    var index;
    if (!variant || !this.$slider.length) {
      return;
    }
    mediaId = variant.featured_media && variant.featured_media.id ? variant.featured_media.id : variant.featured_image && variant.featured_image.id ? variant.featured_image.id : null;
    if (!mediaId) {
      return;
    }
    index = parseInt(this.$slider.find('[data-product-image="' + mediaId + '"]').attr("data-product-image-index"), 10);
    if (Number.isFinite(index)) {
      this.select(index);
    }
  };
  QuickshopGallery.prototype.unload = function() {
    this.$paginationTrigger.off(this.namespace);
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }
  };
  function QuickshopModal(environment, payload, trigger, options) {
    var modalParts = getNativeModalParts();
    var jq = getJQueryInstance();
    options = options || {};
    this.environment = environment;
    this.payload = payload;
    this.trigger = trigger || null;
    this.modalClass = options.modalClass || "quickshop-slim";
    this.logPrefix = options.logPrefix || "Quickshop";
    this.submitNamespace = String(options.submitNamespace || "auxito-quickshop");
    this.variantNamespace = String(options.variantNamespace || "auxito-quickshop-variant-helper");
    this.galleryNamespace = String(options.galleryNamespace || "auxito-quickshop-gallery");
    this.currentModalId = typeof options.currentModalId === "function" ? options.currentModalId : null;
    this.submitHandler = typeof options.submitHandler === "function" ? options.submitHandler : null;
    this.closeCallback = typeof options.closeCallback === "function" ? options.closeCallback : null;
    this.openCallback = typeof options.openCallback === "function" ? options.openCallback : null;
    this.showStockStatus = options.showStockStatus === true;
    this.$jq = jq;
    this.modalParts = modalParts;
    this.$modal = jq && modalParts ? jq(modalParts.container) : null;
    this.$modalContent = jq && modalParts ? jq(modalParts.content) : null;
    this.$root = null;
    this.$form = null;
    this.$productAtcButton = null;
    this.$productVariants = null;
    this.$productOptions = null;
    this.$details = null;
    this.$message = null;
    this.$stockStatus = null;
    this.gallery = null;
    this.variantHelper = null;
    this.resizeHandler = positionNativeQuickshopModal;
    this.context = payload && payload.data && payload.data.context ? payload.data.context : {};
    this.settings = payload && payload.data && payload.data.settings ? payload.data.settings : {};
    this.product = payload && payload.data ? payload.data.product : null;
  }
  QuickshopModal.prototype.getSelectedVariant = function() {
    var selectedId = this.$productVariants && this.$productVariants.length ? String(this.$productVariants.val() || "") : "";
    var variants = Array.isArray(this.product && this.product.variants) ? this.product.variants : [];
    var availableVariant = null;
    var index;
    for (index = 0; index < variants.length; index += 1) {
      if (selectedId && String(variants[index].id) === selectedId) {
        return variants[index];
      }
      if (!availableVariant && variants[index].available) {
        availableVariant = variants[index];
      }
    }
    return availableVariant || variants[0] || null;
  };
  QuickshopModal.prototype.ensureStockStatus = function() {
    var $pricing;
    var $statusRow;
    if (!this.showStockStatus || !this.$jq || !this.$details || !this.$details.length) {
      return;
    }
    this.$stockStatus = this.$details.find("[data-so-quickshop-stock]").first();
    if (this.$stockStatus.length) {
      return;
    }
    this.$stockStatus = this.$jq('<p class="so-quickshop-stock" data-so-quickshop-stock aria-live="polite"></p>');
    $statusRow = this.$details.find("[data-so-quickshop-status-row]").first();
    if ($statusRow.length) {
      $statusRow.prepend(this.$stockStatus);
      return;
    }
    $pricing = this.$details.find(".product-pricing").first();
    if ($pricing.length) {
      $pricing.after(this.$stockStatus);
    } else {
      this.$details.append(this.$stockStatus);
    }
  };
  QuickshopModal.prototype.updateStockStatus = function(variant) {
    var quantity;
    var isLowStock;
    var text;
    if (!this.showStockStatus || !this.$stockStatus || !this.$stockStatus.length) {
      return;
    }
    if (!variant) {
      this.$stockStatus.text("").attr("hidden", true);
      return;
    }
    quantity = parseInt(variant.inventory_quantity, 10);
    isLowStock = variant.available && Number.isFinite(quantity) && quantity > 0 && quantity <= 10;
    text = variant.available ? "In stock" : "Out of stock";
    if (isLowStock) {
      text = "Only " + quantity + " left";
    }
    this.$stockStatus
      .text(text)
      .removeAttr("hidden")
      .toggleClass("is-sold-out", !variant.available)
      .toggleClass("is-low-stock", !!isLowStock);
  };
  QuickshopModal.prototype.open = function() {
    var self = this;
    var closeButton;
    var modalId;
    if (!this.$jq || !this.modalParts || !this.modalParts.content || !ensureQuickshopMarkupLoaded(this.payload)) {
      return false;
    }
    clearNativeModalClasses(this.modalParts.container);
    this.$modalContent.empty().append(this.$jq(this.payload.quickshopEl).contents());
    this.$root = this.$modalContent;
    hydrateQuickshopLazyImages(this.modalParts.content);
    updateCurrencyNodes(this.modalParts.content);
    this.$form = this.$root.find("[data-product-form]");
    this.$productAtcButton = this.$root.find("[data-product-atc]").first();
    this.$productVariants = this.$root.find("[data-variants]");
    this.$productOptions = this.$root.find("[data-product-option]");
    this.$details = this.$root.find("[data-product-details]").first();
    this.$message = this.$root.find("[data-product-quickshop-message]").first();
    this.toggleMessage("", false);
    this.ensureStockStatus();
    if (this.$form.length && this.submitHandler) {
      this.$form.on("submit." + this.submitNamespace, function(event) {
        self.handleSubmit(event);
      });
    }
    if (this.$root.find("[data-product-gallery]").length) {
      try {
        this.gallery = new QuickshopGallery({
          $gallery: this.$root.find("[data-product-gallery]").first(),
          settings: this.settings,
          namespace: this.galleryNamespace
        });
      } catch (error) {
        console.warn("Failed to initialize " + this.logPrefix + " gallery:", error);
        this.gallery = null;
      }
    }
    if (this.$productVariants.length && this.$productOptions.length && this.product) {
      try {
        this.variantHelper = new VariantHelper(this.product, this.$productVariants, this.$productOptions, function(data) {
          self.switchVariant(data);
        }, this.variantNamespace);
      } catch (error) {
        console.warn("Failed to initialize " + this.logPrefix + " variant helper:", error);
        this.variantHelper = null;
      }
    }
    if (!this.variantHelper) {
      this.updateStockStatus(this.getSelectedVariant());
    }
    modalId = this.currentModalId ? this.currentModalId(this.payload, this.product) : "auxito-quickshop-" + String(this.payload && this.payload.handle ? this.payload.handle : "default");
    this.$modal.addClass("modal--" + this.modalClass);
    document.body.classList.add("modal-loaded", "scroll-lock");
    document.body.setAttribute("data-current-modal", modalId);
    window.requestAnimationFrame(function() {
      document.body.classList.add("modal-visible");
    });
    window.addEventListener("resize", this.resizeHandler);
    positionNativeQuickshopModal();
    initQuickshopThirdParty(this.payload);
    if (this.$jq("[name=doubly-currencies]").length) {
      this.$jq("[name=doubly-currencies]").trigger("change");
    }
    if (typeof this.openCallback === "function") {
      this.openCallback(this);
    }
    closeButton = this.$modal.find("[data-modal-close]").get(0);
    if (closeButton) {
      window.setTimeout(function() {
        try {
          closeButton.focus();
        } catch (error) {}
      }, 0);
    }
    return true;
  };
  QuickshopModal.prototype.switchVariant = function(data) {
    if (!data || !data.variant) {
      return;
    }
    if (this.$productVariants.length) {
      this.$productVariants.val(data.variant.id);
    }
    if (this.gallery) {
      this.gallery.variantChange(data.variant);
    }
    this.updateStockStatus(data.variant);
    if (data.firstLoad) {
      return;
    }
    this.updatePrice(data.variant);
    this.updateBadge(data.variant);
    this.updateButton(data.variant);
    this.updateSku(data.variant);
  };
  QuickshopModal.prototype.updateSku = function(variant) {
    var $skuWrap;
    var $skuValue;
    var skuValue;
    if (!this.$details || !this.$details.length) {
      return;
    }
    $skuWrap = this.$details.find(".product-sku").first();
    $skuValue = $skuWrap.find("[data-product-sku]");
    if (!$skuWrap.length || !$skuValue.length) {
      return;
    }
    skuValue = variant && typeof variant.sku === "string" ? variant.sku : "";
    $skuWrap.toggleClass("product-sku--empty", !skuValue);
    $skuValue.text(skuValue);
  };
  QuickshopModal.prototype.updatePrice = function(variant) {
    var $compareAt;
    var $compareAtMoney;
    var $priceMoney;
    var hasComparePrice;
    if (!this.$details || !this.$details.length) {
      return;
    }
    $compareAt = this.$details.find("[data-price-compare-at]");
    $compareAtMoney = $compareAt.find(".money");
    $priceMoney = this.$details.find("[data-price] .money");
    hasComparePrice = !!variant.compare_at_price && variant.compare_at_price > variant.price;
    $compareAt.toggleClass("visible", hasComparePrice);
    if ($compareAtMoney.length) {
      $compareAtMoney.text(this.environment.formatShopifyMoneyCents(variant.compare_at_price, this.settings.money_format));
    }
    if ($priceMoney.length) {
      $priceMoney.text(this.environment.formatShopifyMoneyCents(variant.price, this.settings.money_format));
    }
    updateCurrencyNodes(this.$details[0]);
  };
  QuickshopModal.prototype.updateBadge = function(variant) {
    var $badge;
    var $badgeMoneySaved;
    var $badgePercentSaved;
    var priceSaved;
    if (!this.$details || !this.$details.length) {
      return;
    }
    $badge = this.$details.find("[data-badge-sales]");
    $badgeMoneySaved = this.$details.find("[data-price-money-saved]");
    $badgePercentSaved = this.$details.find("[data-price-percent-saved]");
    priceSaved = variant.compare_at_price ? variant.compare_at_price - variant.price : 0;
    $badge.toggle(!!priceSaved);
    if ($badgeMoneySaved.length) {
      $badgeMoneySaved.text(this.environment.formatShopifyMoneyCents(priceSaved, this.settings.money_format));
    }
    if ($badgePercentSaved.length && variant.compare_at_price) {
      $badgePercentSaved.text(Math.round(priceSaved * 100 / variant.compare_at_price));
    }
    updateCurrencyNodes(this.$details[0]);
  };
  QuickshopModal.prototype.updateButton = function(variant) {
    var label;
    var nextText;
    if (!this.$productAtcButton || !this.$productAtcButton.length) {
      return;
    }
    label = this.$productAtcButton.find(".atc-button--text");
    nextText = variant.available ? this.context.product_available || "Add to cart" : this.context.product_unavailable || "Sold out";
    if (label.length) {
      label.text(nextText);
    } else {
      this.$productAtcButton.text(nextText);
    }
    this.$productAtcButton.toggleClass("disabled", !variant.available).prop("disabled", !variant.available);
  };
  QuickshopModal.prototype.toggleMessage = function(message, isVisible) {
    if (!this.$message || !this.$message.length) {
      return;
    }
    this.$message.html(message || "").toggleClass("visible", !!isVisible);
  };
  QuickshopModal.prototype.handleSubmit = function(event) {
    if (event) {
      event.preventDefault();
    }
    if (typeof this.submitHandler === "function") {
      this.submitHandler(this, event);
    }
  };
  QuickshopModal.prototype.close = function() {
    if (this.$form && this.$form.length) {
      this.$form.off("." + this.submitNamespace);
    }
    if (this.variantHelper) {
      this.variantHelper.unload();
      this.variantHelper = null;
    }
    if (this.gallery) {
      this.gallery.unload();
      this.gallery = null;
    }
    window.removeEventListener("resize", this.resizeHandler);
    if (this.$jq && this.$modalContent && this.payload && this.payload.quickshopEl) {
      this.$jq(this.payload.quickshopEl).append(this.$modalContent.contents());
      this.$modalContent.empty();
    }
    clearNativeModalClasses(this.modalParts.container);
    if (this.modalParts.inner) {
      this.modalParts.inner.style.marginTop = "";
    }
    document.body.classList.remove("modal-loaded", "scroll-lock", "modal-visible");
    document.body.removeAttribute("data-current-modal");
    if (typeof this.closeCallback === "function") {
      this.closeCallback(this);
    }
    if (this.trigger && typeof this.trigger.focus === "function") {
      window.setTimeout(function(trigger) {
        try {
          trigger.focus();
        } catch (error) {}
      }, 0, this.trigger);
    }
  };
  function createEnvironment(options) {
    var config = Object.assign({
      batchRequestSize: 12,
      defaultQuickBuySettings: {
        cartRedirection: false,
        moneyFormat: window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : "${{amount}}"
      },
      buildBatchUrl: null,
      buildSingleUrl: null,
      enableBatchFetch: true,
      payloadCache: new Map,
      fetchText: null,
      dedupeStrings: dedupeStrings
    }, options || {});
    var payloadCache = config.payloadCache || new Map;
    var environment = {};
    function resolveDedupe(items) {
      return typeof config.dedupeStrings === "function" ? config.dedupeStrings(items) : dedupeStrings(items);
    }
    function buildQuickshopBatchUrl(handles) {
      if (typeof config.buildBatchUrl === "function") {
        return config.buildBatchUrl(handles);
      }
      var url = new URL("/pages/search-result", window.location.origin);
      url.searchParams.set("view", "search-result-cards");
      url.searchParams.set("handles", resolveDedupe(handles).join(","));
      return url.toString();
    }
    function buildQuickshopSingleUrl(handle) {
      if (typeof config.buildSingleUrl === "function") {
        return config.buildSingleUrl(handle);
      }
      return "/products/" + encodeURIComponent(handle) + "?view=search-result-card";
    }
    function buildQuickshopPayload(handle, rootNode) {
      var quickshopEl;
      var data;
      var modalHtml;
      var quickBuySettings;
      if (!rootNode || !rootNode.querySelector) {
        return null;
      }
      quickshopEl = rootNode.querySelector("[data-product-quickshop]");
      data = parseEmbeddedJson(rootNode.querySelector("[data-product-quickshop-data]")) || {};
      modalHtml = parseEmbeddedJson(rootNode.querySelector("[data-product-quickshop-html]")) || "";
      quickBuySettings = parseEmbeddedJson(rootNode.querySelector("[data-quick-buy-settings]")) || {};
      if (!quickshopEl || !modalHtml) {
        return null;
      }
      data.settings = data.settings || {};
      if (typeof data.settings.cart_redirection === "undefined") {
        data.settings.cart_redirection = typeof quickBuySettings.cart_redirection !== "undefined" ? !!quickBuySettings.cart_redirection : !!config.defaultQuickBuySettings.cartRedirection;
      }
      if (!data.settings.money_format) {
        data.settings.money_format = config.defaultQuickBuySettings.moneyFormat;
      }
      return {
        handle: handle,
        quickshopEl: quickshopEl,
        data: data,
        modalHtml: modalHtml,
        quickBuySettings: quickBuySettings
      };
    }
    function parseQuickshopBatchMarkup(markup) {
      var doc;
      var payloadMap = new Map;
      if (typeof DOMParser === "undefined") {
        throw new Error("DOMParser unavailable");
      }
      doc = (new DOMParser).parseFromString(markup, "text/html");
      Array.prototype.forEach.call(doc.querySelectorAll("[data-search-result-card]"), function(wrapper) {
        var handle = String(wrapper.getAttribute("data-search-result-card") || "").trim();
        var payload = buildQuickshopPayload(handle, wrapper);
        if (!handle || !payload) {
          return;
        }
        payloadMap.set(handle, payload);
      });
      return payloadMap;
    }
    function createTrackedQuickshopRequest(handle) {
      var deferred = createDeferred();
      var request = deferred.promise.catch(function(error) {
        payloadCache.delete(handle);
        throw error;
      });
      payloadCache.set(handle, request);
      return deferred;
    }
    async function fetchQuickshopPayloadBatch(handles) {
      var orderedHandles = (handles || []).map(function(handle) {
        return String(handle || "").trim();
      }).filter(Boolean);
      var pendingRequests = new Map;
      var unresolvedHandles;
      var handleChunks;
      var index;
      if (!orderedHandles.length || typeof config.fetchText !== "function") {
        return [];
      }
      resolveDedupe(orderedHandles).forEach(function(handle) {
        if (payloadCache.has(handle)) {
          return;
        }
        pendingRequests.set(handle, createTrackedQuickshopRequest(handle));
      });
      if (pendingRequests.size) {
        unresolvedHandles = new Set(Array.from(pendingRequests.keys()));
        handleChunks = chunkItems(Array.from(pendingRequests.keys()), config.batchRequestSize);
        for (index = 0; index < handleChunks.length; index += 1) {
          var chunk = handleChunks[index];
          try {
            var payloadMap = parseQuickshopBatchMarkup(await config.fetchText(buildQuickshopBatchUrl(chunk)));
            chunk.forEach(function(handle) {
              var deferred = pendingRequests.get(handle);
              if (!deferred) {
                return;
              }
              if (payloadMap.has(handle)) {
                deferred.resolve(payloadMap.get(handle));
              } else {
                deferred.reject(new Error("Quickshop payload not found for " + handle));
              }
              unresolvedHandles.delete(handle);
            });
          } catch (error) {
            unresolvedHandles.forEach(function(handle) {
              var deferred = pendingRequests.get(handle);
              if (deferred) {
                deferred.reject(error);
              }
            });
            break;
          }
        }
      }
      return Promise.all(orderedHandles.map(function(handle) {
        var request = payloadCache.get(handle);
        return request ? request.catch(function() {
          return null;
        }) : Promise.resolve(null);
      }));
    }
    async function fetchQuickshopPayloadSingle(handle) {
      var markup;
      var doc;
      var wrapper;
      if (typeof config.fetchText !== "function") {
        return null;
      }
      markup = await config.fetchText(buildQuickshopSingleUrl(handle));
      if (!markup || !markup.trim()) {
        return null;
      }
      doc = (new DOMParser).parseFromString(markup, "text/html");
      wrapper = doc.querySelector("[data-search-result-card]");
      return wrapper ? buildQuickshopPayload(handle, wrapper) : null;
    }
    async function fetchQuickshopPayload(handle) {
      var cacheKey = String(handle || "").trim();
      var payloads;
      var payload;
      var single;
      if (!cacheKey) {
        return null;
      }
      if (config.enableBatchFetch !== false) {
        try {
          payloads = await fetchQuickshopPayloadBatch([ cacheKey ]);
          payload = payloads.length ? payloads[0] : null;
          if (payload) {
            return payload;
          }
        } catch (error) {}
      }
      try {
        single = await fetchQuickshopPayloadSingle(cacheKey);
        if (single) {
          payloadCache.set(cacheKey, Promise.resolve(single));
          return single;
        }
      } catch (error) {}
      return null;
    }
    function resetModal() {
      var parts = getNativeModalParts();
      var jq = getJQueryInstance();
      if (parts && parts.content) {
        if (parts.content.innerHTML) {
          jq ? jq(parts.content).empty() : parts.content.innerHTML = "";
        }
        clearNativeModalClasses(parts.container);
        if (parts.inner) {
          parts.inner.style.marginTop = "";
        }
      }
      document.body.classList.remove("modal-loaded", "scroll-lock", "modal-visible");
      document.body.removeAttribute("data-current-modal");
    }
    environment.getJQueryInstance = getJQueryInstance;
    environment.parseEmbeddedJson = parseEmbeddedJson;
    environment.updateCurrencyNodes = updateCurrencyNodes;
    environment.hydrateQuickshopLazyImages = hydrateQuickshopLazyImages;
    environment.initQuickshopThirdParty = initQuickshopThirdParty;
    environment.getNativeModalParts = getNativeModalParts;
    environment.clearNativeModalClasses = clearNativeModalClasses;
    environment.positionNativeQuickshopModal = positionNativeQuickshopModal;
    environment.ensureQuickshopMarkupLoaded = ensureQuickshopMarkupLoaded;
    environment.buildCartAddRequestBody = buildCartAddRequestBody;
    environment.postCartAddRequest = postCartAddRequest;
    environment.formatShopifyMoneyCents = function(value, moneyFormat) {
      return formatShopifyMoneyCents(value, moneyFormat, config.defaultQuickBuySettings.moneyFormat);
    };
    environment.fetchQuickshopPayloadBatch = fetchQuickshopPayloadBatch;
    environment.fetchQuickshopPayloadSingle = fetchQuickshopPayloadSingle;
    environment.fetchQuickshopPayload = fetchQuickshopPayload;
    environment.hasPayload = function(handle) {
      return payloadCache.has(String(handle || "").trim());
    };
    environment.resetModal = resetModal;
    environment.createQuickshop = function(payload, trigger, quickshopOptions) {
      return new QuickshopModal(environment, payload, trigger, quickshopOptions);
    };
    return environment;
  }
  window.AuxitoQuickshopRuntime={
    createEnvironment: createEnvironment,
    getJQueryInstance: getJQueryInstance,
    parseEmbeddedJson: parseEmbeddedJson,
    updateCurrencyNodes: updateCurrencyNodes,
    formatShopifyMoneyCents: formatShopifyMoneyCents,
    buildCartAddRequestBody: buildCartAddRequestBody,
    postCartAddRequest: postCartAddRequest
  };
})(window, document);
